import { useEffect, useState, useContext } from "react";
import AppStateContext from "contexts/AppStateContext";
import { apiGetOrder } from "util/network/Orders";
import { useParams } from "react-router";
import OrderHistoryDetails from "vaerksComponents/orderHistoryRowComponents/OrderHistoryDetails";
import { OrderType } from "types/OrderTypes";
import { Container } from "@mui/material";

type OrderHistoryPage = {
  orderId: string;
};

const OrderHistoryPage = () => {
  const { strings, token } = useContext(AppStateContext);

  let { orderId } = useParams<OrderHistoryPage>();

  const [order, setOrder] = useState<OrderType>();

  useEffect(() => {
    if (orderId) {
      apiGetOrder(token, orderId).then((order) => setOrder(order));
    }
  }, [orderId, token]);
  return (
    <Container maxWidth="md" sx={{ marginBottom: "2em" }}>
      {order && <OrderHistoryDetails order={order} />}
    </Container>
  );
};
export default OrderHistoryPage;
